import { OutletHighlightMessageUI } from "./OutletHighlightMessageUI";

export function OutletHighlightMessage() {
  return <OutletHighlightMessageUI />;
}
